<template>
    <transition :name="$route.meta.transition || 'fade'">
        <div>
            <!-- NEWGraph-BxW -->
            <div class="grid">
                <div style="grid-row: 1; grid-column: 1" class="hidden lg:block">
                    <perspective-graph />
                </div>
                <div style="grid-row: 1; grid-column: 1">
                    <div class="container mx-auto overflow-hidden">
                        <!-- Header -->
                        <div class="min-h-app flex flex-col justify-center">
                            <div class="my-8 flex flex-col lg:flex-row gap-8">
                                <div class="w-full lg:w-[60%] z-10 text-center md:text-left">
                                    <span class="text-blue uppercase">
                                        {{ $t('homepage_our_analysis') }}
                                        {{ $t('homepage_your_trading_success') }}
                                        {{ $t('over_70_hit_rate') }}
                                    </span>
                                    <h1>{{ $t('chart_analysis_title') }}</h1>
                                    <span class="block mb-4 mt-6 uppercase">{{ $t('realtime_signals') }}</span>

                                    <p class="base_normal mt-6 w-[70%] 2xl:w-[80%]">
                                        {{ $t('find_best_assets') }}
                                    </p>

                                    <div class="flex flex-col lg:flex-row gap-2 lg:gap-4 mt-8 justify-center md:justify-start">
                                        <router-link to="/produkte">
                                            <FormButton class="lg:w-auto" styling="w-full lg:w-auto primary lg:xl text-xs md:text-base" value="Zur Analyse"> </FormButton>
                                        </router-link>
                                        <!-- "Abo verschenken" Button -->
                                        <router-link
                                            v-if="region === 'de'"
                                            to="/geschenk"
                                            class="relative inline-flex items-center justify-center px-4 py-2 border border-gray-400 rounded-lg hover:bg-blue/20 transition-colors text-blue-dark font-semibold text-xs md:text-base"
                                        >
                                            <div class="flex items-center gap-2">
                                                <i class="fi fi-rr-gift text-lg"></i>
                                                <span>Jetzt Abo verschenken</span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div v-if="region === 'de'" class="flex flex-col mt-8">
                                        <p class="font-bold text-2xl text-center lg:text-left">{{ $t('homepage_app_now') }}</p>
                                        <p>{{ $t('homepage_app_download') }}</p>
                                        <div class="flex w-full justify-center lg:justify-start gap-2">
                                            <a href="https://apps.apple.com/de/app/hkcm/id6499010943" class="h-auto" target="_blank">
                                                <img
                                                    alt="Apple Store"
                                                    class="object-contain max-h-[50px]"
                                                    :src="
                                                        $asset(
                                                            i18next().language === 'de' ? '/hkcm/images/apple-store-badge.png' : '/hkcm/images/apple-store-badge-en.png',
                                                            'public'
                                                        )
                                                    "
                                                />
                                            </a>
                                            <a href="https://play.google.com/store/apps/details?id=de.hkcm.app&hl=de&pli=1" class="h-auto" target="_blank">
                                                <img
                                                    alt="Google Play Store"
                                                    class="object-contain max-h-[50px]"
                                                    :src="
                                                        $asset(
                                                            i18next().language === 'de' ? '/hkcm/images/google-play-badge.png' : '/hkcm/images/google-play-badge-en.png',
                                                            'public'
                                                        )
                                                    "
                                                />
                                            </a>
                                        </div>
                                    </div>
                                    <div class="relative mt-24 lg:w-fit">
                                        <div class="absolute -inset-2 blur-md bg-white opacity-90 -z-10"></div>
                                        <small>
                                            {{ $t('homepage_cooperation') }}
                                        </small>
                                        <div class="flex flex-row gap-6 items-center mt-4">
                                            <img
                                                alt="Thomson Reuters"
                                                class="h-8 w-6/12 object-contain lg:w-auto"
                                                :src="$asset('/hkcm/images/partners/thomson-reuters.png', 'public')"
                                            />
                                            <img alt="SUP Global" class="h-6 w-6/12 object-contain lg:w-auto" :src="$asset('/hkcm/images/partners/sup-global.png', 'public')" />
                                        </div>
                                        <div class="pt-6">
                                            <small>
                                                {{ $t('homepage_awarded') }}
                                            </small>
                                        </div>
                                        <div class="flex flex-row gap-1 lg:gap-6 items-center mt-4">
                                            <img
                                                alt="Black Bull Krypto Insider"
                                                class="w-2/4 object-contain max-h-[180px] lg:w-auto"
                                                :src="$asset('/hkcm/images/partners/BlackBull24_Krypto.png', 'public')"
                                            />
                                            <img
                                                alt="Black Bull Investment Visionär"
                                                class="w-2/4 object-contain max-h-[180px] lg:w-auto"
                                                :src="$asset('/hkcm/images/partners/BlackBull25_InvestmentVision.png', 'public')"
                                            />
                                            <img
                                                alt="DISQ Trust Siegel"
                                                class="h-32 w-full object-contain object-left"
                                                :src="
                                                    $asset(
                                                        i18next().language === 'de'
                                                            ? '/hkcm/images/partners/DISQTrust_Siegel_Von Kunden_Empfohlen_HKCM.png'
                                                            : '/hkcm/images/partners/DISQTrust_Siegel_Von Kunden_Empfohlen_HKCM_global.png',
                                                        'public'
                                                    )
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="relative w-full lg:w-[40%]">
                                    <div class="lg:block">
                                        <div class="absolute top-0 right-0 lg:top-auto lg:bottom-0 w-[320px] flex flex-col z-10">
                                            <div class="relative">
                                                <div class="absolute -top-2 -bottom-2 -left-2 right-0 blur-md bg-white opacity-90 -z-10"></div>
                                                <h3 class="large_bold rounded-lg ibackdrop-blur-[5px] text-right pr-4 opacity-100">
                                                    {{ $t('homepage_subscribe_newsletter') }}
                                                </h3>
                                            </div>

                                            <div class="mt-8 flex flex-row items-center gap-2 text-blue self-end pr-4">
                                                <FormButton
                                                    class="lg:w-auto"
                                                    link="newsletter"
                                                    styling="w-full lg:w-auto secondary lg:xl text-xs md:text-base"
                                                    :value="$t('homepage_register_free')"
                                                >
                                                </FormButton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Header End  -->
                        <div id="graph-background-zoom-stop-1" class="hkcm-graph-stop"></div>
                        <div id="graph-background-zoom-stop-2" class="hkcm-graph-stop"></div>

                        <!--How it works-->
                        <div class="flex flex-row gap-4 lg:gap-8 mt-[200px] lg:my-32 lg:p-16 rounded-lg">
                            <div class="lg:w-1/2"></div>
                            <div class="lg:w-1/2">
                                <small class="text-blue uppercase tracking-widest">{{ $t('used_by_thousands') }}</small>

                                <h2 class="text-left">{{ $t('elliott_wave_headline') }}</h2>
                                <p class="mt-6 text-left" v-html="$t('elliott_wave_text')" />
                            </div>
                        </div>

                        <div class="flex flex-row gap-8 mt-[100px] lg:mt-[200px] lg:my-32 lg:p-16 rounded-lg">
                            <div class="lg:w-1/2">
                                <small class="text-blue uppercase tracking-widest">{{ $t('vision_to_leadership') }}</small>
                                <h2 class="text-left">{{ $t('founders_headline') }}</h2>
                                <p class="mt-6 text-left" v-html="$t('founders_paragraph')" />
                            </div>
                            <div class="lg:w-1/2"></div>
                        </div>

                        <!-- Overview -->
                        <div class="my-10 lg:my-32 grid grid-cols-1 lg:grid-cols-5 gap-8">
                            <div id="animate-to" class="relative col-span-1 lg:col-span-3" />

                            <div class="col-span-1 lg:col-span-2 z-10">
                                <small class="text-blue uppercase tracking-widest">
                                    {{ $t('homepage_overview_glance') }}
                                </small>
                                <div class="hkcm-graph-stop"></div>

                                <h2 class="mt-6">
                                    {{ $t('homepage_overview_perform') }}
                                </h2>

                                <p class="mt-6">
                                    {{ $t('homepage_overview_leading') }}
                                </p>

                                <router-link to="/produkte">
                                    <div class="flex flex-row items-center gap-3 ml-3 mt-6 text-blue cursor-pointer group">
                                        <Icon type="Signet" viewBox="0 0 66 66" width="66" height="66" />
                                        <h3 class="base_bold text-blue-dark">
                                            {{ $t('homepage_glance_products') }}
                                        </h3>
                                        <Icon
                                            type="ArrowRight"
                                            viewBox="0 0 29 21"
                                            width="20"
                                            height="12"
                                            class="fill-none stroke-current group-hover:ml-2 transition-all ease-in-out"
                                        />
                                    </div>
                                </router-link>
                                <div class="grid grid-cols-1 md:grid-cols-2 mt-6 gap-4">
                                    <ProductCategorySingle
                                        v-for="category in $store.getters['product_categories/get']()"
                                        :key="category.id"
                                        :animate="true"
                                        :data="category"
                                        :anchor="true"
                                        class="bg-white"
                                        @jump-to-category="jumpToCategory"
                                    />
                                </div>
                            </div>
                        </div>
                        <!-- Overview End -->

                        <!-- Markets -->
                        <div id="learn-more" class="my-32">
                            <div class="text-center">
                                <small class="text-blue uppercase tracking-widest">
                                    {{ $t('plain_advantages') }}
                                </small>

                                <h2 class="mt-6">
                                    {{ $t('homepage_hkcm_advantages_head') }}
                                </h2>
                            </div>

                            <div id="cube-rect" class="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-y-0 lg:gap-x-80 relative mt-16">
                                <div
                                    class="z-10 hkcm-hover-box pb-6 p-4 hkcm-hover-box-up-left transition duration-500 ease-in-out rounded-lg hover:bg-slate-100/10 hover:shadow-inner hover:shadow-[#031837]/20"
                                >
                                    <div class="flex flex-row gap-8 items-center">
                                        <div id="profitableEntriesIcon" class="w-16 h-16">
                                            <!-- <Icon type="Click" viewBox="0 0 75 72" width="100%" height="100%" /> -->
                                        </div>
                                        <h3 class="xl2_bold">{{ $t('investment_main_goal') }}</h3>
                                    </div>
                                    <p class="mt-8">
                                        {{ $t('investment_main_goal_text') }}
                                    </p>
                                </div>
                                <div
                                    class="z-10 hkcm-hover-box pb-6 p-4 hkcm-hover-box-up-right transition duration-500 ease-in-out rounded-lg hover:bg-slate-100/10 hover:shadow-inner hover:shadow-[#031837]/20"
                                >
                                    <div class="flex flex-row gap-8 items-center">
                                        <div id="priceTargetZoneIcon" class="w-16 h-16">
                                            <!-- <Icon type="Candles" viewBox="0 0 66 67" width="100%" height="100%" /> -->
                                        </div>
                                        <h3 class="xl2_bold">{{ $t('no_crystal_ball') }}</h3>
                                    </div>
                                    <p class="mt-8">
                                        {{ $t('elliott_wave_analysis_description') }}
                                    </p>
                                </div>
                                <div
                                    class="z-10 hkcm-hover-box pb-6 p-4 hkcm-hover-box-down-left transition duration-500 ease-in-out rounded-lg hover:bg-slate-100/10 hover:shadow-inner hover:shadow-[#031837]/20"
                                >
                                    <div class="flex flex-row gap-8 items-center">
                                        <div id="realTimeMessageIcon" class="w-16 h-16">
                                            <!-- <Icon type="Notify" viewBox="0 0 76 76" width="100%" height="100%" /> -->
                                        </div>
                                        <h3 class="xl2_bold">{{ $t('realtime_entry_signals') }}</h3>
                                    </div>
                                    <p class="mt-8">{{ $t('realtime_alerts_description') }}</p>
                                </div>
                                <div
                                    class="z-10 hkcm-hover-box pb-6 p-4 hkcm-hover-box-down-right transition duration-500 ease-in-out rounded-lg hover:bg-slate-100/10 hover:shadow-inner hover:shadow-[#031837]/20"
                                >
                                    <div class="flex flex-row gap-8 items-center">
                                        <div id="financialJournalismIcon" class="w-16 h-16">
                                            <!-- <Icon type="Paper" viewBox="0 0 76 76" width="100%" height="100%" /> -->
                                        </div>
                                        <h3 class="xl2_bold">{{ $t('independent_financial_journalism') }}</h3>
                                    </div>
                                    <p class="mt-8">
                                        {{ $t('hkcm_newsroom_description') }}
                                    </p>
                                </div>

                                <template v-if="screenIsLarge">
                                    <perspective-cube />
                                </template>
                            </div>
                        </div>
                        <!-- Markets End -->

                        <!-- Vorteile -->
                        <div class="my-32">
                            <div class="text-center">
                                <small class="text-blue uppercase tracking-widest">
                                    {{ $t('plain_products') }}
                                </small>

                                <h2 class="mt-6">
                                    {{ $t('homepage_our_markets') }}
                                </h2>
                            </div>

                            <div v-if="productCategories().length" id="categoriesBig" class="mt-16 max-w-xs sm:max-w-full">
                                <Tabs
                                    v-if="productCategories().length"
                                    ref="categoriesBigRef"
                                    :data="productCategories()"
                                    :overlay="true"
                                    align="center"
                                    :active-color="backgroundColor"
                                    :active-tab="activeTab"
                                    :first-on-load="true"
                                    @update:active-tab="(_, key) => updateActiveTab(key)"
                                >
                                    <template #header="{ data }">
                                        <strong>
                                            {{ $translate(data.name) }}
                                        </strong>
                                    </template>

                                    <template #item="{ data }">
                                        <div v-if="data" class="grid grid-cols-1 lg:grid-cols-4 gap-16">
                                            <div class="lg:col-span-1">
                                                <h3 class="xl2_bold">
                                                    {{ $translate(data.name) }}
                                                </h3>

                                                <div class="mt-4" v-html="$translate(data.description)"></div>
                                                <FormButton
                                                    class="w-auto mt-4"
                                                    styling="bg-blue text-white"
                                                    :background-color="backgroundColor"
                                                    :text-color="'#ffffff'"
                                                    :value="$t('plain_all_products')"
                                                    @click="$router.push('/produkte')"
                                                >
                                                </FormButton>
                                            </div>

                                            <Loading class="lg:col-span-3" :loading="!isAllLoaded">
                                                <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
                                                    <ProductGroupSingleBig
                                                        v-for="product_group in getProductGroupByProductCategoryId(data.id)?.data.data"
                                                        :key="product_group.id"
                                                        :data="product_group"
                                                        :background-color="data.background_color"
                                                        :background-gradient="data.background_gradient"
                                                    />
                                                </div>
                                            </Loading>
                                        </div>
                                    </template>
                                </Tabs>
                            </div>
                        </div>
                        <!-- Vorteile End -->
                    </div>
                </div>
            </div>

            <div class="container mx-auto mb-4 lg:my-32">
                <h2 class="text-center">Allgemeines FAQ:</h2>
                <div v-for="(faq, key) in faqs" :key="key">
                    <Accordeon :title="$t(faq.question)" :content="$t(faq.answer)" :headline-number="2" />
                </div>
            </div>

            <!-- Social -->
            <div class="py-32 bg-blue-dark text-white">
                <div class="text-center container mx-auto">
                    <small class="uppercase tracking-widest">
                        {{ $t('homepage_social_sub') }}
                    </small>

                    <h2 class="mt-6">
                        {{ $t('homepage_social_head') }}
                    </h2>

                    <h3 class="base_normal mt-6">
                        {{ $t('homepage_social_text') }}
                    </h3>
                </div>
                <SocialMediaCarousel class="mt-6" />
            </div>
            <!-- Social End -->

            <Recruiting v-if="region === 'de'" />

            <!-- Rezensionen -->
            <div class="container mx-auto">
                <div class="py-32">
                    <h2 class="text-center">
                        {{ $t('homepage_reviews') }}
                    </h2>

                    <Reviews :data="reviews" class="overflow-hidden my-8" />
                </div>
            </div>
            <!-- Rezensionen End-->

            <!-- Summary -->
            <div :class="region === 'de' ? 'lg:mt-12' : 'lg:mt-0'" class="container mx-auto mb-16 lg:my-32 lg:p-16 lg:rounded-md lg:shadow-md lg:bg-white">
                <div class="flex flex-col lg:flex-row items-top gap-8">
                    <div class="w-full lg:w-1/2">
                        <h2 class="xl2_bold">
                            {{ $t('homepage_summary_leading') }}
                        </h2>
                    </div>
                    <div class="w-full lg:w-1/2 flex flex-col lg:flex-row gap-2 lg:gap-8 justify-end">
                        <router-link to="/produkte">
                            <FormButton class="lg:w-auto" styling="secondary xl w-full lg:w-auto" :value="$t('plain_subscribe_now')"> </FormButton>
                        </router-link>
                    </div>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-4 mt-6 gap-4">
                    <ProductCategorySingleBig
                        v-for="category in $store.getters['product_categories/get']()"
                        :key="category.id"
                        :data="category"
                        :anchor="true"
                        class="bg-white"
                        @jump-to-category="jumpToCategory"
                    />
                </div>
            </div>
            <!-- Summary End-->
        </div>
    </transition>
</template>

<script>
import i18next from 'i18next';
import lottie from 'lottie-web';
import { mapGetters } from 'vuex';
import AdventCalendarBanner from '../components/AdventCalendarBanner.vue';
import BlackWeekBanner from '../components/blackweek/BlackWeekBanner.vue';
import lottieEchtzeitIcon from '../components/icons/lottie-echtzeit-kurznachrichten.json';
import lottieFinanzjournalismus from '../components/icons/lottie-finanzjournalismus.json';
import lottieZielzonen from '../components/icons/lottie-praezise-zielzonen.json';
import lottieProfitable from '../components/icons/lottie-profitable-zielzonen.json';
import Recruiting from '../components/landingpage/Recruiting.vue';
import Accordeon from '../components/miscellaneous/Accordeon.vue';

export default {
    components: { Accordeon, AdventCalendarBanner, BlackWeekBanner, Recruiting },
    data: () => ({
        cubeActiveSide: 0,
        cubeColor: '#031837',
        cubeGradientColor: '#314158',
        activeTabs: 1,
        activeTab: 0,
        breakpoint: null,
        breakpointChecker: null,
        scrollPercentage: 0,
        screenIsLarge: false,
        reviews: [
            {
                name: 'Roland Förster',
                content: 'homepage_review_roland_förster',
                stars: 5
            },
            {
                name: 'Markus Neundörfer',
                content: 'homepage_review_markus_neundörfer',
                stars: 5
            },
            {
                name: 'Kamil Ka',
                content: 'homepage_review_kamil_ka',
                stars: 4
            },
            {
                name: 'Randy Kramlinger',
                content: 'homepage_review_randy_kramlinger',
                stars: 5
            },
            {
                name: 'Fritz Apelt',
                content: 'homepage_review_fritz_apelt',
                stars: 4
            },
            {
                name: 'Timo Bauer',
                content: 'homepage_review_timo_bauer',
                stars: 5
            }
        ],
        faqs: [
            {
                question: 'faq_best_app_analysis_question',
                answer: 'faq_best_app_analysis_answer'
            },
            {
                question: 'faq_how_elliott_wave_works_question',
                answer: 'faq_how_elliott_wave_works_answer'
            },
            {
                question: 'faq_reliability_elliott_wave_question',
                answer: 'faq_reliability_elliott_wave_answer'
            },
            {
                question: 'faq_free_stock_app_question',
                answer: 'faq_free_stock_app_answer'
            },
            {
                question: 'faq_how_to_analyze_stocks_question',
                answer: 'faq_how_to_analyze_stocks_answer'
            },
            {
                question: 'faq_best_news_app_question',
                answer: 'faq_best_news_app_answer'
            },
            {
                question: 'faq_best_info_about_stocks_question',
                answer: 'faq_best_info_about_stocks_answer'
            },
            {
                question: 'faq_best_analysis_method_question',
                answer: 'faq_best_analysis_method_answer'
            },
            {
                question: 'faq_which_tool_question',
                answer: 'faq_which_tool_answer'
            },
            {
                question: 'faq_methods_of_chart_analysis_question',
                answer: 'faq_methods_of_chart_analysis_answer'
            }
        ]
    }),

    async mounted() {
        this.initLottieIcons();
        this.checkForLargeScreenSize();
        window.addEventListener('resize', this.checkForLargeScreenSize);
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.checkForLargeScreenSize);
    },

    computed: {
        ...mapGetters('product_categories', {
            productCategories: 'get'
        }),
        ...mapGetters('product_groups', {
            product_groups: 'get',
            getProductGroupByProductCategoryId: 'getByProductCategoryId'
        }),
        ...mapGetters('settings', {
            isAllLoaded: 'isAllLoaded'
        }),
        region() {
            return window.meta.region_configuration.region || 'unknown';
        },

        backgroundColor() {
            const categories = this.productCategories();

            if (categories[this.activeTab] && categories[this.activeTab].background_color) {
                return categories[this.activeTab].background_color;
            }

            return '#ffffff';
        }
    },

    methods: {
        i18next() {
            return i18next;
        },
        updateActiveTab(key) {
            if (typeof key === 'undefined') {
                return;
            }

            this.activeTab = Number(key ?? '0');
        },
        initLottieIcons() {
            function setup(doc_id, lottie_data, delay = 0) {
                const iconAnimation = lottie.loadAnimation({
                    container: document.getElementById(doc_id),
                    animationData: lottie_data,
                    renderer: 'svg',
                    loop: false,
                    autoplay: true
                });
                iconAnimation.addEventListener('complete', () => {
                    setTimeout(() => {
                        iconAnimation.goToAndPlay(0, true);
                    }, delay);
                });
            }

            setup('profitableEntriesIcon', lottieProfitable, 5000);
            setup('priceTargetZoneIcon', lottieZielzonen, 7300);
            setup('realTimeMessageIcon', lottieEchtzeitIcon, 6300);
            setup('financialJournalismIcon', lottieFinanzjournalismus, 4700);
        },

        checkForLargeScreenSize() {
            if (window.matchMedia(`(min-width:${this.$tw.theme.screens.lg})`).matches === true) {
                this.screenIsLarge = true;
            } else {
                this.screenIsLarge = false;
            }
        },

        jumpToCategory(data) {
            const prodCategories = this.productCategories();

            if (prodCategories) {
                for (let index = 0; index < prodCategories.length; index++) {
                    if (prodCategories[index].slug?.name == data?.slug?.name) {
                        this.activeTab = index;
                        this.$refs.categoriesBigRef.activateCategory(data?.slug?.name);
                        break;
                    }
                }
            }

            document.getElementById('categoriesBig').scrollIntoView({
                behavior: 'smooth'
            });
        }
    }
};
</script>
